export const VENUE_UUID = "6ec75a67-ec21-4155-84a8-f5d1a9f0b039"
export const ORG_NAME = "gra"
export const BASE_URL = "https://use1a-production-ordering-api.venuenext.net/v2/proxy"
export const PRIVACY_POLICY_URL = "https://www.nhl.com/coyotes/team/privacy-policy"
export const BRAINTREE_TOKEN = "production_hc3drwc3_8p9hhdtph2bjqyr6"
export const HIDE_MERCH_STANDS = false
export const SHOW_APPLE_PAY = true